<div class="container">
  <nav class="navbar navbar-expand-lg navbar-light bg-light">
    <a class="navbar-brand" href="https://www.zayamed.com/" target="_blank" >zaya</a>
    <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav ml-auto">
        <li routerLinkActive="active" class="nav-item">
          <a class="nav-link" href="https://www.zayamed.com/" target="_blank" i18n="site navigation|The home page of the application.@@navigationHome">HOME</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://www.zayamed.com/beyondmodernmedicine" target="_blank" i18n="site navigation|The podcast page of the application.@@navigationPodcast">PODCAST</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://www.zayamed.com/events" target="_blank" i18n="site navigation|The events page of the application.@@navigationEvents">EVENTS</a>
        </li>
        <li routerLinkActive="active" class="nav-item">
          <a class="nav-link" [routerLink]="['/home']" i18n="site navigation|The practitioner page of the application.@@navigationFindPractitioner">FIND A PRACTITIONER</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://www.zayamed.com/listyourpractice" target="_blank" i18n="site navigation|The practice page of the application.@@navigationPractice">LIST YOUR PRACTICE</a>
        </li>
        <li class="nav-item">
          <a class="nav-link" href="http://www.zayamed.com/about" target="_blank" i18n="site navigation|The story page of the application.@@navigationStory">OUR STORY</a>
        </li>
        <li routerLinkActive="active" class="nav-item" *ngIf="!user">
          <a class="nav-link" [routerLink]="['/login']" i18n="site navigation|Entry point for logging into the application or registering.@@navigationLogin">Log in</a>
        </li>
        <li class="nav-item dropdown" *ngIf="user">
          <a class="nav-link dropdown-toggle" href="#" id="userDropdownMenu" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <ng-container i18n="header|Simple greeting for the user.@@headerHello">Hello,</ng-container> {{ user.isAdmin ? 'Admin' : user.firstName }}
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="userDropdownMenu">
            <a *ngIf="!user.isAdmin" class="dropdown-item" [routerLink]="['/practitioner', user.id]" i18n="site navigation|Entry point for viewing a user's profile.@@navigationProfile">My Profile</a>
            <a *ngIf="!user.isAdmin" class="dropdown-item" [routerLink]="['/practitioner/' + user.id + '/bookings']" i18n="site navigation|Entry point for viewing a practitioner's bookings.@@navigationBookings">My Bookings</a>
            <a *ngIf="user.isAdmin" class="dropdown-item" [routerLink]="['/admin/practitioners']" i18n="site navigation|Entry point for viewing list of all practitioners.@@navigationViewPractitioners">View Practitioners</a>
            <a class="dropdown-item" href="javascript:void()" (click)="onLogout()" i18n="site navigation|Logging out of the application.@@navigationLogout">Logout</a>
          </div>
        </li>
      </ul>
    </div>
  </nav>
</div>
<hr class="mb-5 mt-0">
